import React from 'react'
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback } from 'reactstrap';

export const FormMorphology = (props) => {

    const {
        handleInputChange, validaciones, morphology,
    } = props;

    const {
        morphology_valid
    } = validaciones;

    return (
        <Form className="" role="form" >
            <ModalBody>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label className="col-form-label">Morfologia <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Input
                                type="text"
                                className="form-control form-control-sm input-air-primary"
                                name="morphology"
                                onChange={handleInputChange}
                                value={morphology}
                                autoComplete="off"
                                invalid={morphology_valid}
                            />
                            <FormFeedback>Minimo 1 caracter</FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>

        </Form>
    )
}
